import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponseTable } from '../models/ResponseTable';
import { environment } from '../../environments/environment';
import { User } from '../models/user';
import { RequestPassword } from '../models/RequestPassword';
import { UserOtp } from '../models/UserOtp';
import { CodeResponse, EmailCode } from '../models/EmailCode';


@Injectable({
  providedIn: 'root'
})
export class UsersService {
  url = environment.apiUrl;
  xigaMovil = environment.xigaMovil;

  
  constructor(private http:HttpClient) {
   
   }

  getUsers(clientNumber:number):Observable<ResponseTable>{
    let params='?clientNumber=' + clientNumber;
    return this.http.get<ResponseTable>(this.url + 'User' + params);
  }

  addUser(user:User):Observable<User>{
    return this.http.post<User>(this.url + 'User/create',  user);
  }

  updateUser(user:User):Observable<User>{
    return this.http.put<User>(this.url + 'User',  user);
  }

  deleteUser(user:User):Observable<User>{
  
    let params ="?userId="+ user.userId +"&clientNumber="+ user.clientNumber
    return this.http.delete<User>(this.url + 'User' + params);
  }

  userPassword(request:RequestPassword):Observable<RequestPassword>{
    return this.http.put<RequestPassword>(this.url + 'User/userPassword',  request);
  }

  sendOTPCode(request:UserOtp):Observable<UserOtp>{
    return this.http.post<UserOtp>(this.xigaMovil + 'api/sendOTPCode',  request);

  }
  validateOTPCode(code:string,clientNumber:number,userId:number,type:number,phone:string):Observable<any>{
    const params='?code=' + code +'&clientNumber='+clientNumber+'&userId='+userId+'&type='+type+'&phone='+phone
    return this.http.get<any>(this.url + 'user/validate/otp'+  params);
  }

  saveEmailOTP(request:EmailCode):Observable<EmailCode>{
    return this.http.post<EmailCode>(this.url + 'User/saveEmailOTP',  request);
  }
  
  getEmailOTP(email:string,code:string,clientNumber:number,userId:number):Observable<any>{
    //string email,string code,int clientNumber,int userId
    let params='?email=' + email+"&code="+code+"&clientNumber="+clientNumber+"&userId="+userId;
    return this.http.get<any>(this.url + 'User/validate/otp/email'+  params);

  }

  getDevicesbyUser(clientId:number, userId:string):Observable<any>{
    let params='?clientId=' + clientId +'&userId='+ userId
    return this.http.get<any>(this.url + 'movements/device'+  params);

  }
  deleteDevicesbyUser(data: any): Observable<any> {
    const url = `${this.url}movements/device`;
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: data,
    };
    return this.http.request<any>('delete', url, options);
  }

  saveDevicesbyUser(data: any[]): Observable<any[]> {
    return this.http.post<any[]>(this.url + 'movements/device', data);
  }
  
  validatePhoneNumber(clientNumber: number, phoneNumber: string, type : number,dialCode:string) {
    let data = {
      phoneNumber: phoneNumber,
      clientNumber: clientNumber,
      type: type,
      dialCode:dialCode,
    }
    return this.http.post(this.url + 'user/validate/phone', data);
  }

  ActivateUser(clientNumber:number, userId:number, isValid:boolean){
    const data ={
      clientNumber,
      userId,
      isValid
    }
    return this.http.post(this.url +'user/activateUser',data)
  }

  resendEmail(user:User):Observable<any>{
      return this.http.post(this.url+'user/resend',user)
    }

  validateToken(token: string): Observable<any> {
    return this.http.post(this.url + 'user/validate-token', { Token: token });
  }

  setPassword(token: string, password: string): Observable<any> {
    return this.http.post(this.url + 'user/set-user-password', { Token: token, Password: password });
  }

  sendResetLink(userId: number): Observable<any> {
    return this.http.post(this.url + 'user/send-reset-link/' + userId, {});
  }

}
